import type { ButtonHTMLAttributes } from "react";
import s from "./Button.module.css";

export type ButtonVariant = "primary" | "secondary" | "ghost";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

export function Button({ variant = "primary", className, type = "button", ...rest }: ButtonProps) {
  const classes = className ? `${s.root} ${s[variant]} ${className}` : `${s.root} ${s[variant]}`;
  return <button type={type} className={classes} {...rest} />;
}
